<template>
  <v-row>
    <v-col cols="12">
      <h3 class="mt-0 text-h3">{{ $t('di-text-1') }}</h3>
      <p>{{ $t('di-text-2') }}</p>
    </v-col>
    <v-col cols="12">
      <v-tabs v-model="tab" slider-color="color-new-link-blue" class="ok-tabs debt-info-subtabs" @change="tabPageEvent">
        <v-tab href="#tab-bill-rows" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('debtDetails') }}
        </v-tab>
        <v-tab href="#tab-payment-plan" class="text-subtitle-1 color-new-link-blue--text" v-if="hasActivePaymentPlan">
          {{ $t('paymentPlan') }}
        </v-tab>
        <v-tab href="#tab-payments" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('payments') }}
        </v-tab>
        <v-tab href="#tab-actions" class="text-subtitle-1 color-new-link-blue--text">
          {{ $t('actions') }}
        </v-tab>
        <v-tab href="#tab-part-debtors" class="text-subtitle-1 color-new-link-blue--text" v-if="debt.othersInvolved.length > 0">
          {{ $t('di-text-3') }}
        </v-tab>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-bill-rows">
            <bill-rows :debt="debt"></bill-rows>
          </v-tab-item>
          <v-tab-item value="tab-payment-plan" v-if="hasActivePaymentPlan">
            <payment-plan :paymentPlan="debt.paymentPlan"></payment-plan>
          </v-tab-item>
          <v-tab-item value="tab-payments">
            <debt-payments :payments="debt.payments"></debt-payments>
          </v-tab-item>
          <v-tab-item value="tab-actions">
            <expiration-action-rows :debt="debt"></expiration-action-rows>
          </v-tab-item>
          <v-tab-item value="tab-part-debtors" v-if="debt.othersInvolved.length > 0">
            <part-debtors :debtors="debt.othersInvolved"></part-debtors>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-col>
    <v-col cols="12" v-if="isUpiOrder">
      <h4 class="mt-0 text-h4">{{ $t('di-text-4') }}</h4>
      <a @click="upiPrivacyPolicyDialog = true">{{ $t('di-text-5') }}</a>
    </v-col>
    <v-dialog v-model="upiPrivacyPolicyDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <upi-privacy-policy @close="upiPrivacyPolicyDialog = false"></upi-privacy-policy>
    </v-dialog>
  </v-row>
</template>

<script>
  import BillRows from './BillRows.vue'
  import PartDebtors from './PartDebtors.vue'
  import Payments from './Payments.vue'
  import PaymentPlan from './PaymentPlan.vue'
  import ExpirationActionRows from './ExpirationActionRows.vue'
  import UpiPrivacyPolicy from '../../UpiPrivacyPolicy/UpiPrivacyPolicy.vue'

  export default {
    data: function () {
      return {
        paymentData: {},
        customPaymentDialog: false,
        transferDueDateDialog: false,
        showPaymentPlan: false,
        tab: null,
        upiPrivacyPolicyDialog: false
      }
    },
    props: ['debt'],
    computed: {
      hasActivePaymentPlan () {
        return this.debt.paymentPlan !== null
      },
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      },
      isUpiOrder () {
        return this.debt.upiOrder
      }
    },
    components: {
      'bill-rows': BillRows,
      'part-debtors': PartDebtors,
      'debt-payments': Payments,
      'payment-plan': PaymentPlan,
      'expiration-action-rows': ExpirationActionRows,
      'upi-privacy-policy': UpiPrivacyPolicy
    }
  }
</script>

<style>

  .debt-info-subtabs .v-tabs__container::after {
    background-color: lightgrey;
    height: 4px;
    position: absolute;
    bottom: 0;
    width: 100%;
    content: ' ';
  }

  .debt-info-subtabs .v-tabs__slider-wrapper {
    z-index: 2;
  }

  .debt-info-subtabs .v-tabs__slider {
    height: 4px;
  }
</style>

<i18n>
  {
  "fi": {
  "di-text-1": "Velan tiedot",
  "di-text-2": "Tarkastele velan tarkempia tietoja ja tapahtumahistoriaa.",
  "di-text-3": "Osavelalliset",
  "di-text-4": "Tietosuoja",
  "di-text-5": "Avaa tämän saatavan tietosuojaseloste"
  },
  "se": {
  "di-text-1": "Skuldbeskrivning",
  "di-text-2": "Här kan du kontrollera skuldens detaljuppgifter och se vilka åtgärder som gjorts.",
  "di-text-3": "Solidariskt ansvariga",
  "di-text-4": "Dataskyddsbeskrivning",
  "di-text-5": "Dataskyddsbeskrivning"
  },
  "en": {
  "di-text-1": "Debt information",
  "di-text-2": "Review debt information and action history.",
  "di-text-3": "Part debtors",
  "di-text-4": "Privacy policy",
  "di-text-5": "Privacy policy"
  }
  }
</i18n>
